<template>
    <button class="default-button" :class="{ 'default-button--secondary': isSecondary, 'default-button--red': isRed }"
        @click="press" :disabled="disabled">
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'DefaultButton',

    props: {
        text: {
            type: String,
        },
        isSecondary: {
            type: Boolean,
            default: false
        },
        isRed: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        press() {
            if (!this.disabled) {
                this.$emit('press')
            }
        }
    }
}
</script>

<style lang="scss">
.default-button {
    box-sizing: border-box;
    border: none;
    border-radius: 5px;
    padding: 6px 20px;
    width: 100%;
    max-width: 250px;
    border: 1px solid var(--color-btn);

    cursor: pointer;

    background-color: var(--color-btn);
    color: var(--color-btn-text);
    transition: all 0.2s ease;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    &--secondary {
        background-color: var(--color-bg-dark);
        border: 1px solid var(--color-border);
        color: var(--color-text);

        &:hover {
            background-color: var(--color-bg) !important;
        }

        &:active {
            background-color: var(--color-bg-light) !important;
        }
    }

    &--red {
        background-color: var(--color-red);
        color: var(--color-btn-text);

        &:hover {
            background-color: var(--color-red-light) !important;
        }
    }

    &:hover {
        background-color: var(--color-btn-hover);
    }

    &:active {
        background-color: var(--color-btn-active);
    }
}
</style>
